<template>
  <div class="p-4">
    <form @submit.prevent>
      <h2>
        <span v-if="isEditMode">"{{ editedEntity.name | translate }}" {{ $t("common.update") }}</span>
      </h2>
      <div class="row">
        <div class="col-12">
          <!-- <form class="needs-validation" @submit.prevent="formSubmit"> -->
          <div class="row">
            <div class="col-md-6">
              <h3>{{ $t("account.info") }}</h3>

              <sweet-input
                :isValid="!$v.form.name.$error"
                @input="$v.form.name.$touch()"
                v-model="form.name"
                type="name"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.name-surname')"
                :label="$t('common.name-surname2')"
                class="mt-2"
              />
              <!-- <div v-if="$v.form.name.$error" class="text-danger">
                <div v-if="!$v.form.name.required">
                  {{ $t("common.required") }}
                </div>
              </div> -->

              <sweet-input
                :isValid="!$v.form.phone"
                @input="$v.form.phone"
                v-model="form.phone"
                type="phone"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('common.phone-number')"
                :label="$t('common.phone-number')"
              />

              <label> {{ $t("common.description") }}</label>
              <textarea v-model="form.description" type="text" class="form-control" :placeholder="$t('common.description')" rows="3"></textarea>

              <h3 class="mt-4">{{ $t("account.properties") }}</h3>

              <!-- TO DO -->
              <!-- ROLLER ARASINDAN FILTER SELECT OZELLİĞİ GETİRİLİCEK -->

              <!-- <label> {{ $t("common.roles") }}</label> -->
              <!-- <FilterSelect
                  ref="categoryFilter"
                  :placeholder="$t('common.roles')"
                  :multiple="true"
                  :selected="form.roles"
                  @filter="roleSelectFilter"
                  @changed="roleSelectChanged"
                /> -->

              <label>
                <b-form-checkbox switch v-model="form.active" :value="true" :unchecked-value="false" class="custom-checkbox mb-3" checked>
                  {{ $t("account.is-active") }}
                </b-form-checkbox>
              </label>
              <div>
                <label class="mt-3 pr-2 " for="selectedOption">Kullanıcı Tipi : </label>
                <select id="selectedOption" class="form-control form-control-sm" v-model="form.type">
                  <option value="system">Sistem Kullanıcısı</option>
                  <option value="account">Uygulama Kullanıcısı</option>
                </select>
              </div>
            </div>
            <div class="col-md-6">
              <!--Begin Login Info-->
              <h3>{{ $t("account.credential") }}</h3>

              <sweet-input
                :isValid="!$v.form.email.$error"
                @input="$v.form.email.$touch()"
                v-model="form.email"
                type="email"
                layout="vertical"
                inputClass="mt"
                :placeholder="$t('auth.placeholder.email')"
                :label="$t('common.email')"
                class="mt-2"
              />
              <div v-if="$v.form.email.$error" class="text-danger">
                <div v-if="!$v.form.email.required">
                  {{ $t("common.required") }}
                </div>
                <div v-else-if="!$v.form.email.lowercase">
                  {{ $t("validation.email.lowercase") }}
                </div>
              </div>

              <div>
                <sweet-input
                  :isValid="!$v.form.password.$error"
                  @input="$v.form.password.$touch()"
                  v-model="form.password"
                  type="password"
                  layout="vertical"
                  inputClass="mt"
                  :placeholder="$t('auth.placeholder.password')"
                  :label="$t('common.password')"
                  class="{
                  'is-invalid': submitted && $v.form.password.$error,
                  'is-valid': submitted && !$v.form.password.$error,
                }"
                />
              </div>

              <div v-if="$v.form.password.$error" class="text-danger">
                <div v-if="!$v.form.password.required">
                  {{ $t("validation.password.required") }}
                </div>
                <div v-else-if="!$v.form.password.containsUppercase">
                  {{ $t("validation.password.uppercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsLowercase">
                  {{ $t("validation.password.lowercase") }}
                </div>
                <div v-else-if="!$v.form.password.containsNumber">
                  {{ $t("validation.password.number") }}
                </div>
                <div v-else-if="!$v.form.password.containsSpecial">
                  {{ $t("validation.password.special") }}
                </div>
                <div v-else-if="!$v.form.password.minLength">
                  {{ $t("validation.password.minlength") }}
                </div>
                <div v-else-if="!$v.form.password.maxLength">
                  {{ $t("validation.password.maxlength") }}
                </div>
              </div>

              <div>
                <sweet-input
                  :isValid="!$v.form.confirmPassword.$error"
                  @input="$v.form.confirmPassword.$touch()"
                  v-model="form.confirmPassword"
                  type="password"
                  layout="vertical"
                  inputClass="mt"
                  :placeholder="$t('auth.placeholder.repeat-password')"
                  :label="$t('common.password')"
                  labelClass="mt-2"
                  class="{
                  'is-invalid': submitted && $v.form.confirmPassword.$error,
                  'is-valid': submitted && !$v.form.confirmPassword.$error,
                }"
                />
              </div>
              <div v-if="$v.form.confirmPassword.$error" class="text-danger">
                <div v-if="!$v.form.confirmPassword.required">
                  {{ $t("validation.password.required") }}
                </div>
                <div v-else-if="!$v.form.confirmPassword.sameAsPassword">
                  {{ $t("validation.password.confirm") }}
                </div>
              </div>

              <h6 class="mt-2">{{ $t("common.language") }}</h6>
              <multiselect
                v-model="form.language"
                :isValid="!$v.form.language.$error"
                track-by="language"
                :placeholder="$t('common.language-select')"
                :options="languages"
                :searchable="false"
                :allow-empty="false"
                :show-labels="false"
                @select="onSelect"
              >
                <template slot="singleLabel" slot-scope="{ option }">
                  <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
                  <span class="align-middle">{{ option.title | translate }}</span>
                </template>
                <template slot="option" slot-scope="{ option }">
                  <img :src="`${option.flag}`" alt="user-image" class="mr-1" height="12" />
                  <span class="align-middle">{{ option.title | translate }}</span>
                </template>
              </multiselect>

              <h6 class="mt-2">{{ $t("timezone.name") }}</h6>

              <multiselect
                v-if="timezones"
                v-model="form.timezone"
                track-by="abbr"
                :placeholder="$t('timezone.select-time')"
                :options="timezones"
                :searchable="true"
                :allow-empty="false"
                :show-labels="false"
                label="text"
                @select="onSelect"
              >
              </multiselect>

              <!--End Login Info-->
            </div>
          </div>
          <br />
          <div>
            <b-button
              v-if="!isEditMode"
              @click="save()"
              class="btn-label"
              type="submit"
              :disabled="isUpdating || $v.$invalid"
              variant="success"
              icon="mdi mdi-check"
              size="sm"
              buttonClass="mt-2"
            >
              <i class="bx bx-check-double label-icon"></i>
              {{ $t("common.save") }}
            </b-button>

            <b-button v-else @click="save()" class="btn-label" type="submit" variant="primary" icon="mdi mdi-check" size="sm" buttonClass="mt-2">
              <i class="bx bx-check-double label-icon"></i>
              {{ $t("common.save") }}
            </b-button>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import { email, maxLength, minLength, required, sameAs } from "vuelidate/lib/validators";
const state = "managementAccount";

export default {
  props: {
    closeOnSave: { type: Boolean, default: true },
  },
  components: {},
  data() {
    return {
      form: {
        email: undefined,
        password: undefined,
        confirmPassword: undefined,
        active: null,
        name: undefined,
        language: undefined,
        description: undefined,
        phone: undefined,
        type: "account",
        timezone: undefined,
        accountId: undefined,
      },
      formError: undefined,
    };
  },
  validations: {
    form: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(60),
      },
      email: { lowercase: (value) => value === value?.toLowerCase(), required, email },
      password: {
        /*required,
         minLength: minLength(8),
        maxLength: maxLength(64),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-.]/.test(value);
        },*/
      },
      confirmPassword: {
        sameAsPassword: sameAs("password"),
        /*
         required,
        minLength: minLength(8),
        maxLength: maxLength(64),
        containsUppercase: function(value) {
          return /[A-Z]/.test(value);
        },
        containsLowercase: function(value) {
          return /[a-z]/.test(value);
        },
        containsNumber: function(value) {
          return /[0-9]/.test(value);
        },
        containsSpecial: function(value) {
          return /[#?!@$%^&*-.]/.test(value);
        },*/
      },

      type: {
        required,
      },
      language: {
        required,
      },
    },
  },
  mounted() {
    this.$store.dispatch("localization/fetchTimezones");
  },
  watch: {
    editedEntity: {
      deep: true,
      immediate: true,
      handler(v) {
        this.form = {
          ...v.credential,
          ...v,
          accountId: v._id,
          language: this.languages.find((l) => l.language == v.language),
        };
      },
    },
  },
  computed: {
    account() {
      return this.$store.getters[`${state}/account`];
    },
    timezones() {
      return this.$store.getters["localization/timezones"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
    isUpdating() {
      return this.$store.getters[`${state}/isUpdating`];
    },
    editedEntity() {
      return this.$store.getters[`${state}/editedEntity`];
    },
    isEditMode() {
      return this.$store.getters[`${state}/isEditMode`];
    },
  },
  methods: {
    async save() {
      const ok = await this.confirm(this.$t(`alert.approve`));
      if (!ok) {
        return;
      }
      try {
        let language = this.form._id ? this.form.language.language : this.form.language.language;

        const { data } = await this.$store.dispatch(`${state}/save`, { ...this.form, language });
        this.$toast.success(this.$t("common.success"));
        if (this.closeOnSave) {
          this.$root.$emit("bv::toggle::collapse", "sidebar-edit-account");
        }
        setTimeout(() => this.$emit("onSave", data), 500);
      } catch (error) {
        this.$handleHttpErrorByStatusCode(error);
      }
    },
    anyError(e) {
      this.formError = e;
    },
    onSelect() {
      this.$forceUpdate();
    },
    onSelectType() {
      this.save(this.type);
    },
  },
};
</script>
